import { render } from "./MAXIRACE26_retrait_dossard.vue?vue&type=template&id=f5d5f198"
import script from "./MAXIRACE26_retrait_dossard.vue?vue&type=script&lang=js"
export * from "./MAXIRACE26_retrait_dossard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__